// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100vw;
  height: 100vh;
  position: relative;
}

.scrollbar {
  overflow-y: auto;
}

.scrollbar::-webkit-scrollbar {
  width: 10px;
}

/* Track */
.scrollbar::-webkit-scrollbar-track {
  border-radius: 5px;
}

/* Handle */
.scrollbar::-webkit-scrollbar-thumb {
  background: rgba(94, 175, 255, 0.3);
  border-radius: 5px;
}

/* Handle on hover */
.scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(94, 175, 255, 0.5);
}

.side-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-width: 15vw;
}
.side-container .side-top {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 32px 24px 32px 32px !important;
  height: unset;
}
.side_bar_display .side-container .side-top {
  padding: 24px 0 !important;
  justify-content: center !important;
}
.side-container .side-top > a {
  height: 40px;
}
.side-container .side-middle {
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: center;
  overflow-y: scroll;
  padding: 0 0 0 32px !important;
  width: unset;
}
.side_bar_display .side-container .side-middle {
  padding-left: 0 !important;
}
.side-container .side-middle > mat-accordion {
  padding-right: 32px;
}
.side-container .side-middle > mat-accordion.has-scroll {
  padding-right: 22px;
}
.side-container .side-middle > mat-accordion mat-panel-title {
  margin: 0 !important;
  padding: 0 !important;
}
.side-container .side-middle > mat-accordion .parent-icon-container {
  position: absolute;
}
.side-container .side-middle > mat-accordion .parent-icon-container > img {
  top: 14px;
  left: 0;
}
.side_bar_display .side-container .side-middle > mat-accordion .parent-icon-container > img {
  left: 14px !important;
}
.side-container .side-middle > mat-accordion .mat-expansion-panel-body {
  padding: 0;
}
.side-container .side-middle > mat-accordion > div {
  display: flex;
  position: relative;
}
.side-container .side-middle > mat-accordion > div > img {
  top: 0;
  left: 0;
}
.side-container .side-middle > mat-accordion > div .mat-expansion-panel-header {
  padding: 20px 0 !important;
  margin: 0;
  top: 0;
  margin-left: 48px;
}
.side-container .side-middle > mat-accordion > div .mat-expansion-panel-header .mat-expansion-indicator {
  position: relative;
  right: 3px;
}
.side-container .side-bottom {
  display: flex;
  flex-direction: row;
  height: unset !important;
  justify-content: center;
  justify-content: space-around;
  width: unset;
  padding: 24px 24px 24px 32px !important;
}
.side_bar_display .side-container .side-bottom {
  padding-left: 20px !important;
  left: 0;
}
.side_bar_display .side-container .side-bottom > div {
  display: none;
}
.side-container .side-bottom > * {
  margin-top: auto;
  margin-bottom: auto;
}
.side-container .side-bottom .user-icon {
  display: flex;
  flex-direction: column;
  align-self: center;
}
.side-container .side-bottom .right-chevron {
  display: flex;
  flex-direction: column;
  align-self: center;
  align-content: flex-end;
  margin-left: 80px;
  color: white;
}
.side-container .side-bottom .user-text {
  display: flex;
  flex-direction: column;
  align-self: flex-start;
}
.side-container .side-bottom .user-text h3 {
  padding: 2px;
  margin: 0;
}
.side-container .side-bottom .user-text button {
  margin: 0;
  padding: 2px;
  margin-left: 55px !important;
  max-width: 50px;
}
.side-container .side-bottom > img {
  height: 32px;
  width: 32px;
}

ng-scrollbar {
  --scrollbar-size: 8px;
  --scrollbar-thumb-color: rgba(94, 175, 255, 0.5);
  --scrollbar-thumb-hover-color: dodgerblue;
  --scrollbar-border-radius: 4px;
  /* border: 1px solid gray; */
}

.app-nav-accordion .mat-expansion-panel {
  border-radius: 0px !important;
  box-shadow: none !important;
}
.app-nav-accordion .mat-expansion-panel.mat-expansion-panel-spacing {
  margin: 0px;
}
.app-nav-accordion .mat-expansion-panel .mat-expansion-panel-body {
  padding: 0px;
}
.app-nav-accordion .mat-expansion-panel .mat-expansion-panel-header {
  height: 18px;
  padding: 0px 24px 0px 16px;
}
.app-nav-accordion .mat-expansion-panel .mat-expansion-panel-header-title {
  color: rgba(0, 0, 0, 0.54);
  font-size: 14px;
  font-weight: 500;
}

.nav-icons {
  top: 44px;
  z-index: 1;
  position: relative;
  right: 40px !important;
  cursor: pointer;
}

.user-icon {
  font-size: 20px;
  align-items: center;
}

.upgrade-link {
  color: white;
  margin-left: 50px;
  position: absolute;
  margin-top: -32px;
  margin-left: 62.5%;
  font-size: 15px;
}

.active_account {
  opacity: 1;
}

.inactive_account {
  opacity: 0.4;
}

.perm_identity {
  height: 16px;
  margin: auto 0;
}

.theme1-move-icon {
  filter: brightness(0) invert(1);
}

mat-drawer {
  visibility: visible !important;
  transform: translate3d(calc(72px - 100%), 0, 0);
}

.mat-drawer[style*="visibility: hidden"] {
  display: block;
}

.side_bar_display ~ .mat-drawer-content {
  margin-left: 72px;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AADJ;;AAME;EACE,gBAAA;AAHJ;;AAKE;EACE,WAAA;AAFJ;;AAKE,UAAA;AACA;EAEE,kBAAA;AAHJ;;AAME,WAAA;AACA;EACE,mCAAA;EACA,kBAAA;AAHJ;;AAME,oBAAA;AACA;EACE,mCAAA;AAHJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AAFJ;AAII;EACI,aAAA;EACA,mBAAA;EAEA,uBAAA;EACA,uCAAA;EACA,aAAA;AAHR;AAIQ;EACE,0BAAA;EACA,kCAAA;AAFV;AAIQ;EACE,YAAA;AAFV;AAMI;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;AAJR;AAKQ;EACE,0BAAA;AAHV;AAKQ;EAEE,mBAAA;AAJV;AAKU;EACE,mBAAA;AAHZ;AAKU;EACE,oBAAA;EACA,qBAAA;AAHZ;AAKU;EACE,kBAAA;AAHZ;AAIY;EAEE,SAAA;EACA,OAAA;AAHd;AAIc;EACE,qBAAA;AAFhB;AAMU;EACE,UAAA;AAJZ;AAMU;EACE,aAAA;EACA,kBAAA;AAJZ;AAKY;EACE,MAAA;EACA,OAAA;AAHd;AAKY;EAEE,0BAAA;EACA,SAAA;EACA,MAAA;EACA,iBAAA;AAJd;AAKc;EACE,kBAAA;EACA,UAAA;AAHhB;AASI;EAEI,aAAA;EACA,mBAAA;EAEA,wBAAA;EACA,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,uCAAA;AATR;AAUQ;EAGE,6BAAA;EACA,OAAA;AAVV;AAWU;EACE,aAAA;AATZ;AAYQ;EACE,gBAAA;EACA,mBAAA;AAVV;AAYQ;EACI,aAAA;EACA,sBAAA;EACA,kBAAA;AAVZ;AAYQ;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;AAVV;AAYQ;EACI,aAAA;EACA,sBAAA;EACA,sBAAA;AAVZ;AAWY;EACI,YAAA;EACA,SAAA;AAThB;AAWY;EACI,SAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;AAThB;AAYQ;EACE,YAAA;EACA,WAAA;AAVV;;AAeA;EACC,qBAAA;EACA,gDAAA;EACA,yCAAA;EACA,8BAAA;EACC,4BAAA;AAZF;;AAiBI;EACE,6BAAA;EACA,2BAAA;AAdN;AAgBM;EACE,WAAA;AAdR;AAiBM;EACE,YAAA;AAfR;AAkBM;EACE,YAAA;EACA,0BAAA;AAhBR;AAmBM;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;AAjBR;;AAsBA;EACE,SAAA;EACA,UAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAnBF;;AAqBA;EACE,eAAA;EACA,mBAAA;AAlBF;;AA+BA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AA5BF;;AA8BA;EACE,UAAA;AA3BF;;AA6BA;EACE,YAAA;AA1BF;;AA4BA;EACE,YAAA;EAEA,cAAA;AA1BF;;AA6BA;EACE,+BAAA;AA1BF;;AA6BA;EACE,8BAAA;EACA,+CAAA;AA1BF;;AA6BA;EACE,cAAA;AA1BF;;AA6BA;EACE,iBAAA;AA1BF","sourcesContent":["// @import \"../styles.scss\";\n// @import \"./../component_variable.scss\";\n.container {\n    width: 100vw;\n    height: 100vh;\n    position: relative;\n  }\n\n  .content {\n  }\n  .scrollbar {\n    overflow-y: auto;\n  }\n  .scrollbar::-webkit-scrollbar {\n    width: 10px;\n  }\n\n  /* Track */\n  .scrollbar::-webkit-scrollbar-track {\n    // box-shadow: inset 0 0 5px grey;\n    border-radius: 5px;\n  }\n\n  /* Handle */\n  .scrollbar::-webkit-scrollbar-thumb {\n    background: rgba(94, 175, 255, 0.3);\n    border-radius: 5px;\n  }\n\n  /* Handle on hover */\n  .scrollbar::-webkit-scrollbar-thumb:hover {\n    background:rgba(94, 175, 255, 0.5);\n  }\n.side-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    height: 100%;\n    max-width: 15vw;\n\n    .side-top {\n        display: flex;\n        flex-direction: row;\n        // height: 10%;\n        justify-content: center;\n        padding: 32px 24px 32px 32px !important;\n        height: unset;\n        .side_bar_display & {\n          padding: 24px 0 !important;\n          justify-content: center !important;\n        }\n        > a {\n          height: 40px;\n        }\n\n    }\n    .side-middle {\n        display: flex;\n        flex-direction: row;\n        height: 100%;\n        justify-content: center;\n        overflow-y: scroll;\n        padding: 0 0 0 32px !important;\n        width: unset;\n        .side_bar_display & {\n          padding-left: 0 !important;\n        }\n        > mat-accordion {\n          // padding-right: 24px;\n          padding-right: 32px;\n          &.has-scroll {\n            padding-right: 22px;\n          }\n          mat-panel-title {\n            margin: 0 !important;\n            padding: 0 !important;\n          }\n          .parent-icon-container {\n            position: absolute;\n            > img {\n              // top: 0;\n              top: 14px;\n              left: 0;\n              .side_bar_display & {\n                left: 14px !important;\n              }\n            }\n          }\n          .mat-expansion-panel-body {\n            padding: 0;\n          }\n          > div {\n            display: flex;\n            position: relative;\n            > img {\n              top: 0;\n              left: 0;\n            }\n            .mat-expansion-panel-header {\n              // padding: 0;\n              padding: 20px 0 !important;\n              margin: 0;\n              top: 0;\n              margin-left: 48px;\n              .mat-expansion-indicator {\n                position: relative;\n                right: 3px;\n              }\n            }\n          }\n        }\n    }\n    .side-bottom {\n        // padding: 10px;\n        display: flex;\n        flex-direction: row;\n        // height: 10%;\n        height: unset !important;\n        justify-content: center;\n        justify-content: space-around;\n        width: unset;\n        padding: 24px 24px 24px 32px !important;\n        .side_bar_display & {\n          // padding-left: 0 !important;\n          // padding-right: 0 !important;\n          padding-left: 20px !important;\n          left: 0;\n          > div {\n            display: none;\n          }\n        }\n        > * {\n          margin-top: auto;\n          margin-bottom: auto;\n        }\n        .user-icon {\n            display: flex;\n            flex-direction: column;\n            align-self: center;\n        }\n        .right-chevron {\n          display: flex;\n          flex-direction: column;\n          align-self: center;\n          align-content: flex-end;\n          margin-left: 80px;\n          color: white;\n        }\n        .user-text {\n            display: flex;\n            flex-direction: column;\n            align-self: flex-start;\n            h3 {\n                padding: 2px;\n                margin: 0;\n            }\n            button {\n                margin: 0;\n                padding: 2px;\n                margin-left: 55px !important;\n                max-width: 50px;\n            }\n        }\n        > img {\n          height: 32px;\n          width: 32px;\n        }\n\n    }\n}\nng-scrollbar {\n\t--scrollbar-size: 8px;\n\t--scrollbar-thumb-color: rgba(94, 175, 255, 0.5);\n\t--scrollbar-thumb-hover-color: dodgerblue;\n\t--scrollbar-border-radius: 4px;\n\t /* border: 1px solid gray; */\n  }\n\n\n  .app-nav-accordion {\n    .mat-expansion-panel {\n      border-radius: 0px !important;\n      box-shadow: none !important;\n\n      &.mat-expansion-panel-spacing {\n        margin: 0px;\n      }\n\n      .mat-expansion-panel-body {\n        padding: 0px;\n      }\n\n      .mat-expansion-panel-header {\n        height: 18px;\n        padding: 0px 24px 0px 16px;\n      }\n\n      .mat-expansion-panel-header-title {\n        color: rgba(0,0,0,0.54);\n        font-size: 14px;\n        font-weight: 500;\n      }\n    }\n  }\n\n.nav-icons {\n  top: 44px;\n  z-index: 1;\n  position: relative;\n  right: 40px !important;\n  cursor: pointer;\n}\n.user-icon{\n  font-size: 20px;\n  align-items: center;\n  //background-color: $primary-dark !important;\n}\n// .icon-active{\n//   color: $warn !important;\n// }\n// .icon-inactive{\n//   color: $primary !important;\n// }\n// ::ng-deep mat-drawer{\n//   background-color: $primary-dark-menu !important;\n// }\n\n.upgrade-link {\n  color: white;\n  margin-left: 50px;\n  position: absolute;\n  margin-top: -32px;\n  margin-left: 62.5%;\n  font-size: 15px;\n}\n.active_account {\n  opacity: 1;\n}\n.inactive_account{\n  opacity: .4;\n}\n.perm_identity {\n  height: 16px;\n  // margin-top: 25px;\n  margin: auto 0;\n}\n\n.theme1-move-icon {\n  filter: brightness(0) invert(1);\n}\n\nmat-drawer {\n  visibility: visible !important;\n  transform: translate3d(calc(72px - 100%), 0, 0);\n}\n\n.mat-drawer[style*=\"visibility: hidden\"] {\n  display: block;\n}\n\n.side_bar_display ~ .mat-drawer-content {\n  margin-left: 72px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
